module.exports = __webpack_public_path__ + "media/MyAudio_5.a3036bd2.mp3";